module.exports = __webpack_public_path__ + "img/jj-1.9dae6d1a.jpg";